module.exports = __webpack_public_path__ + "static/media/dashboard_speed.69cd759d.jpg";